import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment.prod';
import {Observable} from "rxjs";
@Injectable({
  providedIn: 'root'
}) 
export class SoaImageService {
  private _saveMobiileFolderUrl = `${environment.api}/SoaImage/saveMobileFolder`;
  private _getMobileFolderListUrl = `${environment.api}/SoaImage/getMobileFolderList`;
  private _getFolderInfoUrl = `${environment.api}/SoaImage/getMobileFolderInfo`;
  private _getAdditionalMobileUsers = `${environment.api}/SoaImage/getAdditionalMobileUsers`;
  private _updateMobileFolderUrl = `${environment.api}/SoaImage/updateMobileFolder`;
  private _deleteMobileFolderUrl = `${environment.api}/SoaImage/deleteMobileFolder`;
  private _uploadFolderDocUrl = `${environment.api}/SoaImage/uploadFolderDoc`;
  private _getFolderFileListUrl = `${environment.api}/SoaImage/getFolderFileList`;
  private _getcustomerfolderdetail = `${environment.api}/SoaImage/getcustomerfolderdetail`;
  private _deleteFolderFileUrl = `${environment.api}/SoaImage/deleteFolderFile`;
  private _rotateFileUrl = `${environment.api}/SoaImage/rotateImage`;
  private _updateFolderFileNameUrl = `${environment.api}/SoaImage/updateFolderFile`;
  private _companyStampUrl = `${environment.api}/SoaImage/companyStamp`;
 
  private _convertImageToPdfUrl = `${environment.api}/SoaImage/convertImageToPdf`;
  private _applyWaterMarkUrl = `${environment.api}/SoaImage/applyWaterMark`;
  private _mergingFileUrl = `${environment.api}/MergingFile/fileMergning`;
  private _deleteMergeFileUrl = `${environment.api}/MergingFile/deleteMergeFile`;

  private _sendEmailCustomerUrl = `${environment.api}/SoaImage/sendEmailToCustomer`;
  
    private _sendUploadEmailUrl = `${environment.api}/SoaImage/sendUploadEmail`;
    private _sendnotification = `${environment.api}/SoaImage/sendnotification`;

    private _updatePrivateStatus = `${environment.api}/SoaImage/updatePrivateStatus`;

    
    private _SelectPrivateStatus = `${environment.api}/SoaImage/SelectPrivateStatus`;

    private _convertToPdf = `${environment.api}/SoaImage/convertToPdf`;

    private _getFolderForPDF = `${environment.api}/SoaImage/getFolderForPDF`;

    private _imageConvertPdfUrl = `${environment.api}/SoaImage/imageConvertPdf`;

    private _getFiltterDataUrl = `${environment.api}/SoaImage/getSoaFiltterData`;
    
    
  constructor(private http: HttpClient) { }

  updatePrivateStatus(data)
  {
    return this.http.post<any>(this._updatePrivateStatus,data);
  }

  SelectPrivateStatus(data)
  {
    return this.http.post<any>(this._SelectPrivateStatus,data);
  }

  getMobileFolderList(data)
  {
    return this.http.post<any>(this._getMobileFolderListUrl,data);
  }

  sendUploadEmail(data)
  {
    return this.http.post<any>(this._sendUploadEmailUrl,data);
  }

  sendnotification(data)
  {
    return this.http.post<any>(this._sendnotification,data);
  }

  getcustomerfolderdetail(data)
  {
    return this.http.post<any>(this._getcustomerfolderdetail,data);
  }
  saveMobileFOlder(data)
  {
    return this.http.post<any>(this._saveMobiileFolderUrl,data);
  }

  getFolderInfo(data)
  {
    return this.http.post<any>(this._getFolderInfoUrl,data);
  }

  getAdditionalMobileUsers(data){
    return this.http.post<any>(this._getAdditionalMobileUsers,data);
  }

  updateMobileFolder(data)
  {
    return this.http.post<any>(this._updateMobileFolderUrl,data);
  }

  deleteMobileFolder(data)
  {
    return this.http.post<any>(this._deleteMobileFolderUrl,data);
  }

  uploadFolderDoc(data)
  {
    return this.http.post<any>(this._uploadFolderDocUrl,data);
  }

  getFolderFileList1(data): Observable<any>
  {
    return this.http.post<any>(this._getFolderFileListUrl,data);
  }
  getFolderForPDF(data): Observable<any>
  {
    return this.http.post<any>(this._getFolderForPDF,data);
  }

  deleteFolderFile(data)
  {
    return this.http.post<any>(this._deleteFolderFileUrl,data);
  }

  rotateFolderFile(data)
  {
    return this.http.post<any>(this._rotateFileUrl,data);
  }


  updateFolderFileName(data)
  {
    return this.http.post<any>(this._updateFolderFileNameUrl,data);
  }
  

  companyStamp(data)
  {
    return this.http.post<any>(this._companyStampUrl,data);
  }
  
  convertToPdf(data){
    return this.http.post<any>(this._convertToPdf,data); 
  }

  convertImageToPdf(data)
  {
     return this.http.post<any>(this._convertImageToPdfUrl,data);
  }
  
 
  applyWaterMark(data)
  {
     return this.http.post<any>(this._applyWaterMarkUrl,data);
  }
  mergningFile(data)
  {
     return this.http.post<any>(this._mergingFileUrl,data);
  }


  deleteMergeFile(data)
  {
     return this.http.post<any>(this._deleteMergeFileUrl,data);
  }

  sendEmailToCustomer(data)
  {
     return this.http.post<any>(this._sendEmailCustomerUrl,data);
  }
  
  imageConvertPdf(data)
  {
     return this.http.post<any>(this._imageConvertPdfUrl,data);
  }

  getMobileFiltterData(data)
  {
     return this.http.post<any>(this._getFiltterDataUrl,data);
  }
  
   
}
